<template>
  <DrawerContainer
    ref="drawerContainer"
    :dialogShow="dialogShow"
    v-if="dialogShow"
    :dialog-width="'50%'"
    :title="title"
    :has-footer="!isDetail"
    @resetPopupData="dialogShow = false"
    @submitPopupData="submitForm"
  >
    <div class="driver-order-detail custom-form">
      <div class="list-status">
        <div class="list-carInfo">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>司机信息
          </div>
          <div class="list-box">
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">司机姓名</div>
                <div class="bottom-box-value">{{ detail.username }}</div>
              </div>
              <div class="list-bottom-box list-bottom-box2">
                <div class="bottom-box-name">联系电话</div>
                <div class="bottom-box-value">{{ detail.phone }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">所属机构</div>
                <div class="bottom-box-value">
                  {{ detail.companyName || "-" }}
                </div>
              </div>

              <div class="list-bottom-box">
                <div class="bottom-box-name">关联车队长</div>
                <div class="bottom-box-value">
                  <CustomTooltip
                    :text="detail.vehicleLeaderName"
                  ></CustomTooltip>
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">运输路线</div>
                <div class="bottom-box-value">
                  {{ detail.startCityName }}-{{ detail.endCityName }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">常驻地址</div>
                <div class="bottom-box-value">
                  {{ detail.cityName }}{{ detail.districtName }}
                </div>
              </div>
            </div>
          </div>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>车辆信息
          </div>
          <div class="list-box">
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">车牌号码</div>
                <div class="bottom-box-value">{{ detail.carNumber }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车型</div>
                <div class="bottom-box-value">{{ detail.vehicleMode }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车长</div>
                <div class="bottom-box-value">{{ detail.vehicleLength }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">可承载体积</div>
                <div class="bottom-box-value">{{ detail.volume }}方</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">最大承重</div>
                <div class="bottom-box-value">{{ detail.loadBearing }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车牌类型</div>
                <div class="bottom-box-value">{{ detail.carNumberType }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车辆使用性质</div>
                <div class="bottom-box-value">{{ detail.vehicleUseType }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">GPS</div>
                <div class="bottom-box-value">
                  {{ detail.gpsId ? detail.gpsId : "未绑定" }}
                </div>
              </div>
            </div>
          </div>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>三证材料
          </div>
          <div class="info-box">
            <div class="info-box-list">
              <div class="info-name">行驶证</div>
              <el-image
                :src="getFileUrl(detail.vehicleLicenceId)"
                class="info-img"
                :preview-src-list="[getFileUrl(detail.vehicleLicenceId)]"
              ></el-image>
            </div>
            <div class="info-box-list">
              <div class="info-name">驾驶证</div>
              <el-image
                :src="getFileUrl(detail.drivingLicenceId)"
                class="info-img"
                :preview-src-list="[getFileUrl(detail.drivingLicenceId)]"
              ></el-image>
            </div>
            <div class="info-box-list">
              <div class="info-name">身份证</div>
              <el-image
                :src="getFileUrl(detail.idCardId)"
                class="info-img"
                :preview-src-list="[getFileUrl(detail.idCardId)]"
              ></el-image>
            </div>
          </div>
          <!--          <div class="title-box">-->
          <!--            <el-image :src="cheImage" class="title-label"></el-image>日志信息-->
          <!--          </div>-->
          <!--          <div class="log-box">-->
          <!--            <custom-table-->
          <!--              :data="tableData"-->
          <!--              :column="tableColumn"-->
          <!--              :selection="false"-->
          <!--            >-->
          <!--              <template v-slot:status="{ row }">-->
          <!--                <span class="colorf32009">停跑</span>-->
          <!--                &lt;!&ndash;          <span class="operate-btn status-confirm">在跑</span>&ndash;&gt;-->
          <!--              </template>-->
          <!--            </custom-table>-->
          <!--          </div>-->
          <div class="title-box" style="padding-top: 0">
            <el-image :src="cheImage" class="title-label"></el-image>审批结果
          </div>
          <div class="examine2-box" v-if="isDetail">
            <div class="list">
              <span class="label">审批结果：</span>
              <span class="value">{{
                getLocalLabel("auditStatus", detail.auditStatus)
              }}</span>
            </div>
            <div class="list">
              <span class="label">操作人：</span>
              <span class="value">{{ detail.auditUsername }}</span>
            </div>
            <div class="list">
              <span class="label">操作时间：</span>
              <span class="value">{{ detail.auditTime }}</span>
            </div>
            <div class="list" v-if="detail.auditRemark">
              <span class="label">备注：</span>
              <span class="value">{{ detail.auditRemark }}</span>
            </div>
          </div>
          <div class="examine-box" v-else>
            <div class="radio-box">
              <el-radio-group v-model="form.auditStatus">
                <el-radio :label="1">同意</el-radio>
                <el-radio :label="-1">不同意</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-input
                type="textarea"
                clearable
                rows="5"
                placeholder="请输入备注"
                v-model="form.auditRemark"
                show-word-limit
                maxlength="50"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DrawerContainer>
</template>
<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import { detailInfo } from "@/views/FleetLeaderWorkbench/PlatformDriverManagement/api";
import { getFileUrl } from "@/utils/tool";
import { auditDriver } from "@/views/ApprovalCenter/DriverInformationApproval/api";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "AddOrEdit",
  data() {
    return {
      loading: false,
      title: "详情",
      isDetail: false,
      detailImage: require("@/assets/imgs/bg.png"),
      cheImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      dialogShow: false,
      stepData: [
        {
          date: "2025-20-11 10:22:11",
          content: "司机结单",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "装货途经点装货",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "卸货途经点卸货",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "卸货途经点卸货",
          isOver: false,
        },
      ],
      tableData: [
        {
          type: "司机入驻申请",
          date: "2025-20-11 10:22:11",
          personal: "王海洋",
          result: "成功",
        },
        {
          type: "司机入驻申请",
          date: "2025-20-11 10:22:11",
          personal: "王海洋",
          result: "成功",
        },
        {
          type: "司机入驻申请",
          date: "2025-20-11 10:22:11",
          personal: "王海洋",
          result: "成功",
        },
      ],
      tableColumn: [
        {
          label: "操作类型",
          prop: "type",
          align: "left",
          show: true,
        },
        {
          label: "操作时间",
          prop: "date",
          align: "left",
          show: true,
        },
        {
          label: "操作人",
          prop: "personal",
          align: "left",
          show: true,
        },
        {
          label: "操作结果",
          prop: "result",
          align: "left",
          show: true,
        },
      ],
      form: {
        auditStatus: 1,
        auditRemark: "",
      },
      detail: {},
      driverId: "",
    };
  },
  components: {
    CustomTable,
    DrawerContainer,
    CustomTooltip,
  },
  methods: {
    getLocalLabel,
    getFileUrl,
    init(title, isDetail, row) {
      this.title = title;
      this.isDetail = isDetail;
      this.driverId = row.driverId;
      this.getDetail(row.driverId);
      this.dialogShow = true;
    },
    submitForm() {
      this.$refs.drawerContainer.loading = true;
      auditDriver({
        auditPass: this.form.auditStatus === 1 ? true : false,
        auditRemark: this.form.auditRemark,
        driverId: this.driverId,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("司机审核成功");
            this.dialogShow = false;
            this.$parent.handleAddOrEditSuccess(this.driverId ? "edit" : "add");
          }
        })
        .finally(() => {
          this.$refs.drawerContainer.loading = false;
        });
    },
    getDetail(val) {
      this.loading = true;
      detailInfo(val)
        .then((res) => {
          if (res.code === 200) {
            this.detail = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.driver-order-detail {
  .list-box {
    background: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.08rem 0;
      .list-bottom-box {
        width: 15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .list-image {
          width: 0.85rem;
          height: 0.5rem;
          border-radius: 0.05rem;
        }
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.06rem;
        }
        .bottom-box-value {
          color: #434343;
          text-align: center !important;
          font-size: 0.14rem;
        }
      }
      .list-bottom-box2 {
        width: 20%;
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
    .list-bottom2 {
      .list-bottom-box:nth-last-of-type(1):before,
      .list-bottom-box:nth-last-of-type(2):before,
      .list-bottom-box:nth-last-of-type(3):before,
      .list-bottom-box:nth-last-of-type(4):before {
        display: none;
      }
    }
  }
  .list-status {
    display: flex;
    .title-box {
      padding: 0.2rem 0 0;
      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }
    .list-step {
      width: 25%;
    }
    .list-carInfo {
      width: 100%;
    }
    .list-label {
      padding: 0.1rem 0;
    }
    //.list-step-box {
    //  display: flex;
    //  flex-direction: column;
    //  padding: 0 0.3rem 0 0.5rem;
    //  box-sizing: border-box;
    //  .step-list {
    //    border-radius: 0.1rem;
    //    background: #ffffff;
    //    padding: 0.04rem 0.14rem;
    //    box-sizing: border-box;
    //    margin-bottom: 0.5rem;
    //    position: relative;
    //    .step-date {
    //      font-size: 0.12rem;
    //      height: 0.22rem;
    //    }
    //    .step-content {
    //      font-size: 0.14rem;
    //    }
    //  }
    //  .step-list::before {
    //    content: "";
    //    position: absolute;
    //  }
    //}
    .color8c8c8c {
      color: #8c8c8c;
    }
    .color434343 {
      color: #434343;
    }
    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }
  .info-box {
    display: flex;
    .info-box-list {
      margin-right: 0.2rem;
      .info-name {
        color: #8c8c8c;
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding-bottom: 0.1rem;
        padding-top: 0.2rem;
      }
      .info-img {
        width: 1rem;
        height: 1rem;
        border-radius: 0.1rem;
      }
    }
  }
  .log-box {
    padding-top: 0.2rem;
  }
  .examine2-box {
    background-color: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
  }
  .examine-box {
    padding-top: 0.1rem;
    .radio-box {
      margin-bottom: 0.2rem;
      margin-top: 0.1rem;
    }
  }
}
</style>
